import { useState, useEffect } from "react";
import { useUser } from "@clerk/clerk-react";
import { supabase } from "./supabase";

export function useSupabaseUser() {
  const { user, isLoaded } = useUser();
  const [dbUser, setDbUser] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!isLoaded || !user) { setLoading(false); return; }
    const syncUser = async () => {
      setLoading(true);
      try {
        const { data, error } = await supabase
          .from("users")
          .select("*")
          .eq("id", user.id)
          .single();

        if (error || !data) {
          const { data: newUser } = await supabase
            .from("users")
            .insert({
              id: user.id,
              email: user.primaryEmailAddress?.emailAddress,
              full_name: user.fullName,
              avatar_url: user.imageUrl,
              plan: "free",
            })
            .select()
            .single();
          setDbUser(newUser);
        } else {
          setDbUser(data);
        }
      } catch (err) {
        console.error("Supabase sync error:", err);
      }
      setLoading(false);
    };
    syncUser();
  }, [user, isLoaded]);

  const updatePlan = async (plan) => {
    if (!user) return;
    const { data } = await supabase
      .from("users")
      .update({ plan, subscribed_at: new Date().toISOString() })
      .eq("id", user.id)
      .select()
      .single();
    if (data) setDbUser(data);
  };

  const enrollCourse = async (courseId, courseTitle) => {
    if (!user) return;
    const { data: existing } = await supabase
      .from("enrollments")
      .select("*")
      .eq("user_id", user.id)
      .eq("course_id", courseId)
      .single();
    if (!existing) {
      await supabase.from("enrollments").insert({
        user_id: user.id,
        course_id: courseId,
        course_title: courseTitle,
      });
    }
  };

  const getEnrollments = async () => {
    if (!user) return [];
    const { data } = await supabase
      .from("enrollments")
      .select("*")
      .eq("user_id", user.id);
    return data || [];
  };

  return {
    dbUser,
    loading,
    updatePlan:     updatePlan     || (() => {}),
    enrollCourse:   enrollCourse   || (() => {}),
    getEnrollments: getEnrollments || (() => []),
  };
}